import script from "./TeacherTrainAccountView.vue?vue&type=script&setup=true&lang=js"
export * from "./TeacherTrainAccountView.vue?vue&type=script&setup=true&lang=js"

import "./TeacherTrainAccountView.vue?vue&type=style&index=0&id=42e8650a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42e8650a"]])

export default __exports__